import { render, staticRenderFns } from "./FeedbackIcon.vue?vue&type=template&id=d29c9996&scoped=true&lang=pug&"
import script from "./FeedbackIcon.vue?vue&type=script&lang=js&"
export * from "./FeedbackIcon.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackIcon.vue?vue&type=style&index=0&id=d29c9996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29c9996",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
